import { render, staticRenderFns } from "./FormItemConfig.vue?vue&type=template&id=fd5b9fa4&scoped=true"
import script from "./FormItemConfig.vue?vue&type=script&lang=js"
export * from "./FormItemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5b9fa4",
  null
  
)

export default component.exports